import React from 'react';
import './_gamelogs.scss';

const Gamelogs = (props) =>
  ( <div className="card mb-3">
			          <div className="card-header">
			            <i className="fas fa-table" />
			            Gamelogs</div>
			          <div className="card-body">
			            <div className="table-responsive">
			              <table className="table table-bordered" id="dataTable" width="100%" cellSpacing={0}>
			                <thead>
			                  <tr>
			                  <th>Date</th>
			                    <th>Game</th>
			                  </tr>
			                </thead>
			                <tbody>
			                {props.data && (
			                	props.data.map((game, index) => {
									const teamA = game.team_a[0];
									const scoreA = (teamA.score && (teamA.score.toFixed && teamA.score.toFixed(2))) || 0;
									const teamB = game.team_b[0];
									const scoreB = (teamB.score && (teamB.score.toFixed && teamB.score.toFixed(2))) || 0;
									return <tr key={game.team_b[0].score + scoreA} >
												<td>{game.year}, Week {game.week}</td>
												<td>{teamA.name} <strong>{scoreA}</strong>, {teamB.name} <strong>{scoreB}</strong></td>
												</tr>
								})
			                	
			                	)}
			                </tbody>
			              </table>
			            </div>
			          </div>
			          
			        </div>);

export default Gamelogs;
